import React from 'react';
import { Modal } from "react-bootstrap";
import EditActivity from '../Activities/EditActivity/EditActivity';
import AddActivity from '../Activities/AddActivity/AddActivity';

const ActivityFormModal = ({showModal, activityIdToEdit, handleCloseModal, edit}) => {
  return (
    <Modal show={showModal} onHide={handleCloseModal} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>{edit? 'Editar Actividad' : 'Agregar nueva actividad'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {edit ? <EditActivity id={activityIdToEdit} handleCloseModal={handleCloseModal} /> : <AddActivity handleCloseModal={handleCloseModal} />}
      </Modal.Body>
    </Modal>
  )
}

export default ActivityFormModal;